import * as api from 'api/questionnaire';

export const fetchQuestionnaireQuestions = params => ({
  type: 'FETCH_QUESTIONNAIRE_QUESTIONS',
  payload: api.fetchQuestionnaireQuestions(params),
});

export const updateQuestionnaireQuestion = obj => ({
  type: 'UPDATE_QUESTIONNAIRE_QUESTIONS',
  payload: api.updateQuestionnaireQuestion(obj),
});

export const fetchQuestionnaireInstance = params => ({
  type: 'FETCH_QUESTIONNAIRE_INSTANCE',
  payload: api.fetchQuestionnaireInstance(params),
});

export const fetchScores = id => ({
  type: 'FETCH_SCORES',
  payload: api.fetchScores(id),
});
